import { Component } from '@angular/core';
import { NewsletterComponent } from '../../shared/components/newsletter/newsletter.component';

@Component({
  selector: 'app-mesafeli-satis-sozlesmesi',
  standalone: true,
  imports: [NewsletterComponent],
  templateUrl: './mesafeli-satis-sozlesmesi.component.html',
  styleUrl: './mesafeli-satis-sozlesmesi.component.css'
})
export class MesafeliSatisSozlesmesiComponent {

}
